/**
 * Custom JavaScript for MebleFurniture.com
 * Cleaned up: Removed deprecated mutation events, console.logs, and optimized resize handlers
 */

jQuery(document).ready(function($) {
  // Use MutationObserver instead of deprecated DOMNodeInserted/DOMNodeRemoved
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.className && node.className.indexOf('mfp-wrap') !== -1) {
            var heightT = window.innerHeight;
            setTimeout(function() {
              $('body').css({
                'overflow': 'hidden',
                'overflow-y': 'hidden',
                'height': heightT + 'px'
              });
            }, 500);
          }
        });
        mutation.removedNodes.forEach(function(node) {
          if (node.className && node.className.indexOf('mfp-bg') !== -1 && 
              node.className.indexOf('mfp-removing') !== -1) {
            $('body').css('overflow-y', 'auto');
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: false
    });
  }

  // Debounced resize handler for height tracking
  var initial = window.innerHeight;
  var resizeTimeout;
  
  $(window).on('resize.customHeight', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      var currentHeight = window.innerHeight;
      if (currentHeight > initial) {
        $('body').addClass('wc-height-increased');
      } else {
        $('body').removeClass('wc-height-increased');
      }
    }, 100);
  });

  // Tab functionality
  $('.first-tab-active').addClass('active');
  $(document).on('click', '.info-tabs .open-bio', function() {
    $('.first-tab-active').removeClass('active');
    $('.open-bio').removeClass('first-tab-active');
    $(document).find('.bio-more').removeClass('active-description-tab');
    // v21: panels may have just been hidden by the class removal above; keep every toggle's state truthful
    $('.info-tabs .open-bio').each(function() {
      var $panel = $(this).next('.bio-more');
      $(this).attr('aria-expanded', $panel.is(':visible') ? 'true' : 'false');
      $(this).toggleClass('active', $panel.is(':visible'));
    });
  });

  // v21: Magnific Popup lightboxes (gallery zoom, dimensions diagram) announce as dialogs,
  // name their close button, and hand focus back to the element that opened them.
  var mfpOpener = null;
  $(document).on('mfpBeforeOpen', function() {
    mfpOpener = document.activeElement;
  });
  $(document).on('mfpOpen', function() {
    var $wrap = $('.mfp-wrap');
    $wrap.attr({ 'role': 'dialog', 'aria-modal': 'true', 'aria-label': 'Image viewer' });
    $wrap.find('.mfp-close').attr('aria-label', 'Close image viewer');
    $wrap.find('.mfp-arrow-left').attr('aria-label', 'Previous image');
    $wrap.find('.mfp-arrow-right').attr('aria-label', 'Next image');
  });
  $(document).on('mfpImageLoadComplete', function() {
    var mfp = $.magnificPopup.instance;
    if (!mfp || !mfp.currItem) return;
    var alt = (mfp.currItem.data && mfp.currItem.data.title) || (mfp.currItem.el && mfp.currItem.el.attr('title')) || (mfp.currItem.el && mfp.currItem.el.attr('aria-label')) || 'Product image';
    mfp.content.find('img.mfp-img').attr('alt', alt);
  });
  $(document).on('mfpClose', function() {
    if (mfpOpener && typeof mfpOpener.focus === 'function' && document.contains(mfpOpener)) {
      var el = mfpOpener;
      setTimeout(function() { el.focus(); }, 0);
    }
    mfpOpener = null;
  });

  // Move search form on mobile
  if (window.innerWidth <= 1200) {
    $('#header > form').appendTo('#header > .header_bot');
  }

  // FIX: Force Stamped rating to stay big after widget loads
  function fixStampedRatingSize() {
    // Try multiple possible selectors - including the strong tag inside
    var selectors = [
      '.stamped-summary-text-1',
      '.stamped-summary-text-1 strong',
      '.stamped-summary-text-1 > strong',
      '#stamped-main-widget .stamped-summary-text-1',
      '#stamped-main-widget .stamped-summary-text-1 strong',
      '.summary-rating-num',
      '.stamped-summary-text span:first-child',
      '[data-widget-style] .stamped-summary-text-1',
      '.stamped-summary .stamped-summary-text > span:first-child'
    ];
    
    selectors.forEach(function(sel) {
      var els = document.querySelectorAll(sel);
      els.forEach(function(el) {
        el.style.setProperty('font-size', '24px', 'important');
        el.style.setProperty('font-weight', '700', 'important');
        el.style.setProperty('color', '#111', 'important');
        el.style.setProperty('line-height', '1.1', 'important');
      });
    });
  }
  
  // Run repeatedly to catch Stamped's async rendering
  var fixIntervals = [500, 1000, 1500, 2000, 2500, 3000, 4000, 5000];
  fixIntervals.forEach(function(ms) {
    setTimeout(fixStampedRatingSize, ms);
  });
  
  // Also run on any DOM changes within Stamped widget
  var stampedObserver = new MutationObserver(function() {
    fixStampedRatingSize();
  });
  
  function startObservingStamped() {
    var widget = document.getElementById('stamped-main-widget');
    if (widget) {
      stampedObserver.observe(widget, { childList: true, subtree: true, attributes: true });
      fixStampedRatingSize();
    } else {
      setTimeout(startObservingStamped, 500);
    }
  }
  startObservingStamped();
});

/* ==========================================================================
   v24: full-site audit fixes
   ========================================================================== */
(function () {
  'use strict';

  // 1. Collection description accordions (jquery_accordion.js) are click-only <div>s.
  //    Wrap each header's content in a real <button> so Enter / Space work and state is announced.
  //    The click bubbles to the <div>, so the original plugin keeps doing the open/close.
  function initAccordions() {
    var heads = document.querySelectorAll('.accordion-collection .accordion');
    Array.prototype.forEach.call(heads, function (head, i) {
      if (head.querySelector('.acc-toggle')) return;
      var panel = head.nextElementSibling;
      if (panel && !panel.id) panel.id = (head.id || 'accordion-' + i) + '-panel';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'acc-toggle';
      if (panel) btn.setAttribute('aria-controls', panel.id);
      while (head.firstChild) btn.appendChild(head.firstChild);
      head.appendChild(btn);
      var sync = function () { btn.setAttribute('aria-expanded', head.classList.contains('accordion-open') ? 'true' : 'false'); };
      sync();
      if (window.MutationObserver) new MutationObserver(sync).observe(head, { attributes: true, attributeFilter: ['class'] });
    });
  }

  // 2. Stamped renders review photo links with no accessible name
  function labelStampedPhotos() {
    var links = document.querySelectorAll('a.stamped-review-link-photo:not([aria-label])');
    Array.prototype.forEach.call(links, function (a, i) {
      a.setAttribute('aria-label', 'Customer review photo ' + (i + 1) + ' (opens in new tab)');
      var img = a.querySelector('img');
      if (img && !img.hasAttribute('alt')) img.setAttribute('alt', '');
    });
  }

  // 3. Links that open a new tab say so (hidden text, or appended to an existing aria-label)
  function labelNewTabLinks() {
    var links = document.querySelectorAll('a[target="_blank"]:not([data-newtab])');
    Array.prototype.forEach.call(links, function (a) {
      a.setAttribute('data-newtab', '');
      if (a.closest('.klaviyo-form, [class*="kl-private"], [class*="kl-teaser"], a.stamped-review-link-photo')) return;
      var label = a.getAttribute('aria-label');
      if (label) {
        if (!/new (tab|window)/i.test(label)) a.setAttribute('aria-label', label + ' (opens in new tab)');
        return;
      }
      if (/new (tab|window)/i.test(a.textContent)) return;
      // v27: a link named only by its title attribute (footer social icons) keeps that name in an aria-label;
      //      appending hidden text would have made the text the whole name and demoted the title to a description
      var fromContent = (a.textContent || '').trim();
      if (!fromContent) {
        Array.prototype.forEach.call(a.querySelectorAll('img[alt]'), function (img) { fromContent += (img.getAttribute('alt') || '').trim(); });
      }
      if (!fromContent) {
        var title = (a.getAttribute('title') || '').trim();
        if (title) a.setAttribute('aria-label', title + ' (opens in new tab)');
        return;
      }
      var s = document.createElement('span');
      s.className = 'visually-hidden';
      s.textContent = ' (opens in new tab)';
      a.appendChild(s);
    });
  }

  // 4. Header and mobile cart links: label follows the item count the theme updates after add-to-cart
  function syncCartLabels() {
    var links = document.querySelectorAll('[data-cart-link]');
    Array.prototype.forEach.call(links, function (a) {
      var c = a.querySelector('.count, .mobile-sticky-cart-count');
      var n = c ? parseInt(c.textContent, 10) : NaN;
      if (isNaN(n)) return;
      var label = 'Cart, ' + n + (n === 1 ? ' item' : ' items');
      if (a.getAttribute('aria-label') !== label) a.setAttribute('aria-label', label);
    });
  }

  function runAll() { initAccordions(); labelStampedPhotos(); labelNewTabLinks(); syncCartLabels(); }

  function start() {
    runAll();
    if (!window.MutationObserver) return;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(runAll, 300);
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
